import App from '@/js/App';
import GlobalAlert from '@/js/common/ui/alert/GlobalAlert';
import reactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import "@/css/index.css";
import "@/css/font.css";
// import "@/css/unified.css";
import "@/css/common.css";
import "@/css/table.css";
import "@/css/input.css";
import "@/css/common/ui/react-quill.css";
import "react-toggle/style.css" // for ES6 modules
import 'rc-slider/assets/index.css';

const reactRoot = document.querySelector("div#root");

reactDOM
    .createRoot(reactRoot as HTMLElement)
    .render(
        <BrowserRouter>
            <RecoilRoot>
                <GlobalAlert />
                <App /> 
            </RecoilRoot>
        </BrowserRouter>
    );